import React from "react";
import useWhatsappLink from "../../../features/whatsappLink/application/useWhatsappLinks";
import { Spinner } from "../../../components/atoms/Spinner/Spinner";
import { Notification } from "../../../components/molecules/Notification/Notification";
import { WhatsappLinksList } from "../../../components/organism/WhatsappLinkList/WhatsappLinksList";
import { GeneralLayout } from "../../../components/layout/GeneralLayout/GeneralLayout";

export const WhatsappLinksPage: React.FC = () => {
  const { clearError, data } = useWhatsappLink();

  return (
    <GeneralLayout>
      <div className="card max-w-3xl w-full">
        {!data.loading && data.links.length === 0 && (
          <>
            <h1 className="text-2xl font-bold mb-7 mt-7">
              Únete a nuestros grupos
            </h1>
            <p className="text-gray-500 mb-6 text-center">
              No hay grupos disponibles en este momento.
            </p>
          </>
        )}

        {data.loading && <Spinner size="large" />}

        {data.error && (
          <Notification
            message={data.error}
            type="error"
            onClose={clearError}
          />
        )}

        {!data.loading && data.links.length > 0 && (
          <>
            <h1 className="text-2xl font-bold mb-7 mt-7">
              Únete a nuestros grupos
            </h1>
            <p className="text-gray-500 mb-6 text-center">
              Selecciona un grupo de WhatsApp para unirte y mantenerte
              informado.
            </p>

            <WhatsappLinksList links={data.links} />
          </>
        )}
      </div>
    </GeneralLayout>
  );
};
